import React from 'react';
import { PROCESS_STEPS } from '../data/homeData';

function Process() {
  return (
    <section className="process" id="uk-import">
      <div className="process-inner">
        <div className="reveal process-header">
          <span className="section-eyebrow">— India to UK Import</span>
          <h2 className="section-heading centered">From Tamil Nadu farms to your UK warehouse.</h2>
          <p className="section-body centered">
            A clear, dependable import process for British buyers — from sourcing in India
            to delivery at your UK premises.
          </p>
        </div>

        <div className="process-grid">
          {PROCESS_STEPS.map((step) => (
            <div key={step.num} className="reveal process-card hover-lift">
              <span className="process-bg-num">{step.num}</span>
              <div className="process-card-inner">
                <div className="process-num-badge">{step.num}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Process;
